module.exports = __webpack_public_path__ + "img/Luggage.73c39aeb.jpg";